/**
 * Checks if input, select or textarea is empty
 * @param  {Object} field - input, select or textarea Javascript DOM element
 * @returns true if empty, false otherwise
 */
function isFieldEmpty(field) {
  if ($(field).is('input[type="radio"]') && !field.checked) {
    const groupIsChecked = $(
      `input[type="radio"][name="${
        field.name
      }"]:checked`,
    ).length;

    return !groupIsChecked;
  } if (
    ($(field).is('input[type="checkbox"]')
                  && !field.checked)
              || field.value.length === 0
  ) {
    return true;
  }

  return false;
}


module.exports = {
  isFieldEmpty
};
